import React, { useEffect, useState } from "react";
import "./Return_order_details.css";
import Order_id_holder from "../order_details/order_id_holder/Order_id_holder";
import Receiver_info_holder from "../order_details/receiver_info_holder/Receiver_info_holder";
import Breadcrumb_comp from "../../common_components/breadcrumb-comp/Breadcrumb_comp";
import Payment_Summary from "../../cart/payment_summary/Payment_Summary";
import Common_Back_Header from "../../common_components/common_back_header/Common_Back_Header";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getOrder, getReturnedOrder } from "../../../features/order/orderSlice";
import { decodeId, formatDate } from "../../../utils/common";
import Return_order_details_table from "./Return_order_details_table/Return_order_details_table";
import Delivery_boy from "../order_details/delivery-boy/Delivery_boy";
import Delivery_boy_Return from "../order_details/delivery-boy/Delivery_boy_return";

function Return_order_details() {
  const breadcrumbs = [
    { label: "Home", link: "/", isActive: false },
    { label: "MY ORDERS", link: "/account", isActive: false },
    { label: "RETURNED ORDER DETAILS", link: "", isActive: true },
  ];

  const { id } = useParams();

  const [showCancelBtn, setShowCancelBtn] = useState();

  const dispatch = useDispatch();
  const order = useSelector((state) => state.order.order);
  useEffect(() => {
    const res = dispatch(getReturnedOrder(id));
    if (res.meta?.requestStatus === "fulfilled") {
      setShowCancelBtn(false);
    } else if (res.meta?.requestStatus === "rejected") {
      setShowCancelBtn(true);
    }
  }, [dispatch]);

  console.log(order, "RETUREDDDorder");

  const data = {
    total_mrp: order?.total_mrp,
    total_tax: order?.total_tax,
    total_cess: order?.total_cess,
    no_of_item: order?.no_of_item,
    total_selling_price: order?.total_selling_price,
    total_amount: order?.total_amount,
    payment_method: order?.Product_Order?.Payment_Method?.name,
       total_coupon_discount: order?.total_coupon_discount,
    total_offer_discount: order?.total_offer_discount,
    total_selling_price_gst: order?.total_selling_price_gst,
    total_mrp_gst: order?.total_mrp_gst,
  };
  return (
    <>
      <section className="Order_details">
        <div className="container">
          <Common_Back_Header backNavigation="/my-orders" />
          <div className="row">
            <div className=" col-lg-8 col-md-7">
              <Order_id_holder
                headingText={`Order ID #${order?.Product_Order?.invoice_no}`}
                date={formatDate(order?.createdAt)}
                subText="Returned"
                order={order?.Product_Order}
              />
              {order?.User && <Delivery_boy_Return order={order} />}
              <Return_order_details_table order={order} />
            </div>
            <div className="col-lg-4 col-md-5">
              <Receiver_info_holder
                showCancelBtn={showCancelBtn}
                order={order}
                user={order?.Product_Order?.User}
                userAddress={order?.Product_Order?.User_Address}
              />
              <Payment_Summary data={order} refund={true}/>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Return_order_details;
